// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tatle[data-v-f5802f22]{font-size:12px;line-height:18px}.tatle span[data-v-f5802f22]{color:red;padding-right:5px}.icon[data-v-f5802f22]{width:12px;height:12px}", ""]);
// Exports
module.exports = exports;
